const IPIFY_URL = "https://api64.ipify.org?format=json";
const IPAPI_URL = "https://ipapi.co/json/";
const IPWHOIS_URL = "https://ipwho.is/";
const COUNTRY_IS_URL = "https://api.country.is/";
const REST_COUNTRIES_URL = "https://restcountries.com/v3.1/alpha/";

const IP_DETECTION_ERROR = "can't detect your ip address please try again of change your access node";
const RESTRICTED_LOCATION_ERROR = "registration from their location is not permitted";

const getGeoipCountry = () => {
  try {
    const nodeRequire = Function("return typeof module !== 'undefined' && module.require ? module.require : null")();
    if (nodeRequire) return nodeRequire("geoip-country");
  } catch (error) {
    // geoip-country is a Node package, so browser builds may not expose require.
  }

  try {
    const browserRequire = typeof window !== "undefined" && window.require ? window.require : null;
    if (browserRequire) return browserRequire("geoip-country");
  } catch (error) {
    return null;
  }

  return null;
};

const fetchJson = async (url) => {
  const response = await fetch(url);
  if (!response.ok) return null;
  return response.json();
};

const getPublicIp = async () => {
  const data = await fetchJson(IPIFY_URL);
  return data?.ip || null;
};

const parseCallingCode = (callingCode) => {
  if (!callingCode) return null;

  const code = String(callingCode).replace("+", "").split(/[\s-]/)[0];
  const parsedCode = Number(code);
  return Number.isFinite(parsedCode) ? parsedCode : null;
};

const validateCountry = (country) => {
  if (!country?.country || !country?.name || !country?.phone?.length) {
    throw new Error(IP_DETECTION_ERROR);
  }

  if (country.country === "YE") {
    throw new Error(RESTRICTED_LOCATION_ERROR);
  }

  return country;
};

const lookupWithGeoipCountry = async () => {
  const geoip = getGeoipCountry();
  if (!geoip) return null;

  const ip = await getPublicIp();
  if (!ip) return null;

  return geoip.lookup(ip);
};

const lookupWithIpapi = async () => {
  const data = await fetchJson(IPAPI_URL);
  const callingCode = parseCallingCode(data?.country_calling_code);

  if (!data?.country_code || !data?.country_name || !callingCode) return null;

  return {
    country: data.country_code,
    name: data.country_name,
    phone: [callingCode],
  };
};

const lookupWithIpwhois = async () => {
  const data = await fetchJson(IPWHOIS_URL);
  const callingCode = parseCallingCode(data?.calling_code);

  if (data?.success === false || !data?.country_code || !data?.country || !callingCode) return null;

  return {
    country: data.country_code,
    name: data.country,
    phone: [callingCode],
  };
};

const lookupWithCountryIs = async () => {
  const countryData = await fetchJson(COUNTRY_IS_URL);
  if (!countryData?.country) return null;

  const countries = await fetchJson(`${REST_COUNTRIES_URL}${countryData.country}`);
  const country = Array.isArray(countries) ? countries[0] : null;
  const root = country?.idd?.root || "";
  const suffix = country?.idd?.suffixes?.[0] || "";
  const callingCode = parseCallingCode(`${root}${suffix}`);
  const name = country?.name?.common;

  if (!name || !callingCode) return null;

  return {
    country: countryData.country,
    name,
    phone: [callingCode],
  };
};

export const detectRegistrationCountry = async () => {
  const lookups = [
    lookupWithGeoipCountry,
    lookupWithIpapi,
    lookupWithIpwhois,
    lookupWithCountryIs,
  ];

  for (const lookup of lookups) {
    try {
      const country = await lookup();
      if (country) return validateCountry(country);
    } catch (error) {
      if (error.message === RESTRICTED_LOCATION_ERROR) throw error;
    }
  }

  throw new Error(IP_DETECTION_ERROR);
};